function rebuildModalSlides() {
  const mediaList = JSON.parse(
    document.getElementById("ProductMediaJSON").textContent
  );
  const wrapper = document.querySelector(
    "#product-page-swiper .swiper-wrapper"
  );
  if (!wrapper) return;

  // Vacía el wrapper
  wrapper.innerHTML = "";

  mediaList.forEach((media) => {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    slide.setAttribute("data-media-id", media.id);

    // Puedes extender según media_type
    if (media.media_type === "image") {
      // Usa la mejor versión de image_url que tengas
      slide.innerHTML = `<img src="${media.preview_image.src}&width=750" width="900" height="900" loading="lazy" style="max-width:75vw;max-height:100vh;object-fit:contain;">`;
    } else if (
      media.media_type === "video" ||
      media.media_type === "external_video"
    ) {
      slide.innerHTML = `<video controls style="max-width:65vw;max-height:80vh;">
        <source src="${
          media.sources && media.sources[0] ? media.sources[0].url : media.src
        }" type="video/mp4">
        Your browser does not support the video tag.
      </video>`;
    } else if (media.media_type === "model") {
      // Puedes personalizarlo según cómo renderices models
      slide.innerHTML = `<div>3D Model: ${media.alt || media.id}</div>`;
    }
    wrapper.appendChild(slide);
  });
}

// Inicializa Swiper (acepta slide activo opcional)
function initModalSwiper(activeIndex = 0) {
  if (window.modalSwiper && window.modalSwiper.destroy) {
    window.modalSwiper.destroy(true, true);
  }
  window.modalSwiper = new Swiper("#product-page-swiper", {
    navigation: {
      nextEl: ".swiper-button-next-prod-page",
      prevEl: ".swiper-button-prev-prod-page",
    },
    pagination: {
      el: ".swiper-pagination-product-page",
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    initialSlide: activeIndex,
  });

  // Forzar update después de mostrar el modal
  setTimeout(function () {
    window.modalSwiper.update();
  }, 150); // Un delay corto para asegurarse que el modal ya es visible
}

function cleanExtraSlides() {
  document
    .querySelectorAll(".product-media-modal__content > .swiper-slide")
    .forEach((slide) => {
      slide.remove();
    });
}

document.querySelectorAll("[data-modal]").forEach((btn) => {
  btn.addEventListener("click", function () {
    // 1. Elimina slides sueltos por si acaso
    cleanExtraSlides();
    // 2. Regenera slides del modal
    rebuildModalSlides();

    // 3. Calcula índice como siempre
    let slideIndex = 0;
    const mediaId = btn.getAttribute("data-media-id");
    const slides = document.querySelectorAll(
      "#product-page-swiper .swiper-slide"
    );
    if (mediaId) {
      slides.forEach((slide, idx) => {
        if (slide.getAttribute("data-media-id") === mediaId) {
          slideIndex = idx;
        }
      });
    }
    // 4. Inicializa Swiper
    setTimeout(() => {
      initModalSwiper(slideIndex);
    }, 300);
  });
});

function formatMoney(cents, currency = 'USD') {
  const amount = (cents).toFixed(2);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(amount);
}

document.addEventListener("DOMContentLoaded", function () {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const totalPriceEl = document.getElementById("DynamicTotalPrice");

  if (!quantityInput || !totalPriceEl) return;

  const basePrice = parseFloat(totalPriceEl.dataset.basePrice);

  function updateTotal() {
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const total = (basePrice * quantity).toFixed(2);
    totalPriceEl.textContent = formatMoney(basePrice * quantity);
  }

  quantityInput.addEventListener("input", updateTotal);
  quantityInput.addEventListener("change", updateTotal);

  // Handle +/- buttons too
  document.querySelectorAll(".quantity__button").forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(updateTotal, 100); // Delay to wait for input update
    });
  });
});

window.addEventListener("pplrAppInitiated", function () {
  let fields = window.document.querySelectorAll("input.pplr_text");

  if (fields.length === 0) {
    console.log("No text fields found, exiting.");
    return;
  }

  let metalFields = window.document.querySelectorAll(
    "input[name^='properties[Left Metal]'], input[name^='properties[Right Metal]']"
  );

  let renderFields = window.document.querySelectorAll(
    "input[name='properties[left_diamond_render]'], input[name='properties[left_plain_render]'], input[name='properties[right_diamond_render]'], input[name='properties[right_plain_render]']"
  );

  let bagColorFields = window.document.querySelectorAll(
    "input[name^='properties[_Bag Color (for display only)]'], input[name^='properties[_Hardware Color (for display only)]']"
  );

  let leftRenderFields = Array.from(renderFields).slice(0, 2);
  let rightRenderFields = Array.from(renderFields).slice(2, 4);

  let swatches = Array.from(renderFields).map((field) => {
    return field.nextElementSibling;
  });

  let leftSwatches = Array.from(leftRenderFields).map((field) => {
    return field.nextElementSibling;
  });

  let rightSwatches = Array.from(rightRenderFields).map((field) => {
    return field.nextElementSibling;
  });

  function hideRenderFields() {
    for (let i = 0; i < 3; i++) {
      renderFields.forEach(function (field) {
        if (field && field.parentNode) {
          field.parentNode.style.display = "none";
        } else {
          console.error(
            "Field or parent node not found, cannot set display none."
          );
        }
      });
    }
  }

  function updateSwatches(swatchesToUpdate, newDataValue) {
    swatchesToUpdate.forEach((swatch) => {
      const colorSpan = swatch?.querySelector(
        `span[data-color="${newDataValue}"]`
      );

      if (colorSpan) {
        colorSpan.click();
      }
    });
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-value"
      ) {
        let newDataValue = mutation.target.getAttribute("data-value");

        let fieldName = mutation.target.getAttribute("name");
        let isLeftMetal = fieldName.startsWith("properties[Left Metal]");
        let inputValue = mutation.target.value;

        const swatchesToUpdate = isLeftMetal ? leftSwatches : rightSwatches;

        updateSwatches(swatchesToUpdate, newDataValue);

        setTimeout(() => {
          hideRenderFields();
        }, 100);
      }
    }
  });

  metalFields.forEach((input) => {
    observer.observe(input, {
      attributes: true,
      attributeFilter: ["data-value"],
    });
  });

  const bagColorObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "value"
      ) {
        setTimeout(() => {
          hideRenderFields();
        }, 100);
      }
    }
  });

  bagColorFields.forEach((input) => {
    bagColorObserver.observe(input, {
      attributes: true,
      attributeFilter: ["value"],
    });
  });

  let leftTextDiamond = fields[0];
  let leftTextPlain = fields[1];

  let rightTextDiamond = fields[2];
  let rightTextPlain = fields[3];

  let syncing = false;

  function syncTextFields(source, target) {
    if (syncing) return;

    syncing = true;

    if (target.value !== source.value) {
      target.value = source.value;
      target.dispatchEvent(new Event("input", { bubbles: true }));
    }

    syncing = false;
  }

  leftTextDiamond.addEventListener("input", function () {
    leftTextDiamond.value = leftTextDiamond.value.replace(/[^a-zA-Z\s]/g, "");
    syncTextFields(leftTextDiamond, leftTextPlain);
  });

  leftTextPlain.addEventListener("input", function () {
    leftTextPlain.value = leftTextPlain.value.replace(/[^a-zA-Z\s]/g, "");
    syncTextFields(leftTextPlain, leftTextDiamond);
  });

  rightTextDiamond.addEventListener("input", function () {
    rightTextDiamond.value = rightTextDiamond.value.replace(/[^a-zA-Z\s]/g, "");
    syncTextFields(rightTextDiamond, rightTextPlain);
  });

  rightTextPlain.addEventListener("input", function () {
    rightTextPlain.value = rightTextPlain.value.replace(/[^a-zA-Z\s]/g, "");
    syncTextFields(rightTextPlain, rightTextDiamond);
  });

  metalFields.forEach(function (field) {
    field.addEventListener("change", function () {
      leftTextDiamond.dispatchEvent(new Event("input"));
      leftTextPlain.dispatchEvent(new Event("input"));
      rightTextDiamond.dispatchEvent(new Event("input"));
      rightTextPlain.dispatchEvent(new Event("input"));
    });
  });

  hideRenderFields();
});
